import { useTranslation } from "@me8eon/translation";
import React, { useContext } from "react";
import { AiAssistantContext } from "../../../context/AiAssistantContext";
import { Icon } from "@me8eon/icons";
import "./AssistanceTask.scss";
import { EonUiButton } from "@eon-ui/eon-ui-components-react";

const ManualTask = () => {
    const t = useTranslation();
    const { manualRecommendedActions, removeManualActions } = useContext(AiAssistantContext);

    if (!manualRecommendedActions.length) return null;

    return (
        <div className="ai-assist-assistance-task">
            <div className="heading" title={t("chatBot.nexthinkIntegration.myActions")}>
                <Icon size="normal" name="plus_circle" />
                <span>{t("chatBot.nexthinkIntegration.myActions")}</span>
            </div>
            <div className="assistance-task-wrapper">
                {manualRecommendedActions.map((item: string, index: number) => (
                    <div
                        className="assistance-task-item"
                        key={index}
                    >
                        <span> 
                            <Icon
                                name="clock_alt"
                                themedColor="#c4c0c0ff"
                            />
                        </span>
                        <span>
                            {t(item)}
                        </span>
                    </div>
                ))}
            </div>
            <div>
                <EonUiButton 
                    fullWidth
                    text={t("chatBot.nexthinkIntegration.smartSolution.myActionDone")}
                    rank="primary"
                    size="small"
                    onClick={removeManualActions}
                />
            </div>
        </div>
    );
};

export default ManualTask;